import { useCallback } from "react";
import { useNoSubmit } from "src/apps/AppFlow/pages/hooks";
import { FormFlowPage, IllustrativeOptions } from "src/components";
import { createStyles } from "src/styles";
import { noInput } from "src/utilities/input";

import { enums } from "@fraction/shared";

import type { IncomeSourceTypeProps } from "../../index";
import {
  DROPDOWN_LABEL,
  FORM_FLOW_PAGE_DESCRIPTION,
  FORM_FLOW_PAGE_TITLE,
  INCOME_TYPES_SHARED,
  mapIncomeTypesToOptions,
} from "../utilities";

type IncomeSourceTypeCAProps = Omit<IncomeSourceTypeProps, "location">;

const INCOME_TYPES_CA: enums.IncomeType[] = [
  ...INCOME_TYPES_SHARED.slice(0, 4),
  enums.IncomeType.CANADA_CHILD_BENEFIT_INCOME,
  ...INCOME_TYPES_SHARED.slice(4, -1),
];

const styles = createStyles({
  options: {
    marginBottom: "24px",
  },
});

const IncomeSourceTypeCA = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  ...props
}: IncomeSourceTypeCAProps) => {
  const validate = useCallback(() => !noInput(value), [value]);
  const { handleNext, nextDisabled } = useNoSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title={FORM_FLOW_PAGE_TITLE}
      description={FORM_FLOW_PAGE_DESCRIPTION}
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
    >
      <IllustrativeOptions
        label={DROPDOWN_LABEL}
        focusRef={focusRef}
        value={value}
        onChange={onChange}
        options={mapIncomeTypesToOptions(INCOME_TYPES_CA)}
        containerStyle={styles.options}
      />
    </FormFlowPage>
  );
};

export default IncomeSourceTypeCA;
